import { makeRequestStateless } from "@utils/helpers";
import { Button, Col, Drawer, Form, Row, Space, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { createSelectList } from '@comps/commonFunctions';
import { SelectWithSearch, InputText, InputDate, SelectResourceList } from '@comps/components';
import { FilterOutlined, SyncOutlined, SearchOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import BaseSelectTrashedResource from "../layout/BaseSelectTrashedResource";
import BaseSelectWithTrashedResource from "../layout/BaseSelectWithTrashedResource";

import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { useDispatch, useSelector } from "react-redux";
import { setFilterOptions } from "../../redux/filterOptionsSlice";


dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(utc);

const BaseFilter = (props) => {

    const { filters, onFilter, api, moduleName, modkey } = props;
    const [loading, setLoading] = useState(true)
    const [loader, setLoader] = useState(false);
    const [options, setOptions] = useState({});
    const [selectedValues, setSelectedValues] = useState({});
    const [selectedString, setSelectedString] = useState(props.selected)
    const [form] = Form.useForm()

    const dispatch = useDispatch();
    //initial data loading
    const filterOptions = useSelector((state) => state.filterOptions);
    const hasScopedFilterOptions = Boolean(props.optionScopeFilters);
    useEffect(() => {
        getInitialData()
        setData()
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setSelectedString(props.selected)
        setData()
        // eslint-disable-next-line
    }, [props.selected]);

    //api for getting options data
    const getInitialData = async () => {
        const isEmpty = (filterOptions) => Object.keys(filterOptions).length === 0;
        if (hasScopedFilterOptions || isEmpty(filterOptions)) {
            const payload = hasScopedFilterOptions
                ? { ...(moduleName && typeof moduleName === 'object' ? moduleName : {}), scope_filters: props.optionScopeFilters }
                : moduleName;
            await makeRequestStateless(api, payload, onSuccess, null);
        } else {
            setOptions(filterOptions)
            setLoading(false)
        }
    }

    const onSuccess = (data, res) => {
        if (!hasScopedFilterOptions) {
            dispatch(setFilterOptions(data))
        }
        setOptions(data)
        setLoading(false)
    }
    //set pre data
    const setData = () => {
        if (selectedString && selectedString !== undefined && selectedString !== '' && selectedString.eventPhase === undefined) {
            const keyValuePairs = selectedString.split(';');
            const resultObject = {};
            for (const pair of keyValuePairs) {
                if (pair !== "" || pair !== '') {
                    const keyValuObj = convertToKeyValuePair(pair.replace('_|', ':'))
                    // Get keys
                    var key = Object.keys(keyValuObj)[0];
                    // Get values
                    var value = Object.values(keyValuObj)[0];

                    if (/^\d+$/.test(value)) {
                        value = Number(value);
                    }
                    if (value === 'true') {
                        value = 'true'
                    }
                    if (value === 'false') {
                        value = 'false'
                    }
                    if (value === 'undefined' || value === 'null' || !value) {
                        value = ''
                    }
                    if (key === 'from' || key === 'to' || key === 'month' || key === 'from_month' || key === 'end_month' || key === 'year' || key === 'completion_to' || key === 'completion_from') {
                        value = value ? dayjs(value) : ''
                    }

                    if (value && typeof value === 'string' && value.includes(',')) {
                        value = convertToArray(value);
                    }
                    resultObject[key] = value;
                }
            }

            setSelectedValues(resultObject)
            form.setFieldsValue(resultObject)
        } else {
            setSelectedValues({})
            form.resetFields()
        }
    }

    function convertToArray(string) {
        if (!string) return [];
        if (Array.isArray(string)) return string;
        return string.split(',').map(item => {
            return isNaN(item) ? item : Number(item);
        });
    }
    function convertToKeyValuePair(str) {
        var parts = str.split(':');
        var key = parts[0].trim();
        var value = parts[1].trim();
        var result = {};
        result[key] = value;
        return result;
    }

    //is object
    const onChange = (key, value, each) => {
        const nextValue = each && value && (each.type === "text" || each.type === "number")
            ? value.target.value
            : value;

        form.setFieldValue(key, nextValue);
    }
    //apply filter
    const onSubmit = (data) => {
        setLoader(true)
        const currentValues = { ...form.getFieldsValue(true), ...data };
        const normalizedValues = normalizeFilterValues(currentValues);
        let payload = '';

        Object.keys(normalizedValues).forEach((key) => {
            const value = normalizedValues[key];
            if (value !== undefined && value !== null && value !== '') {
                payload += `${key}_|${value};`;
            }
        });

        setSelectedValues(currentValues)
        setSelectedString(payload)
        onFilter(payload);
        if (typeof props.setCurrentPage === 'function') {
            props.setCurrentPage(1);
        }
        props.onCloseFilter(false)
        setLoader(false)
    }

    const onReset = () => {
        setSelectedValues({})
        form.resetFields();
        onFilter('');
        if (typeof props.setCurrentPage === 'function') {
            props.setCurrentPage(1);
        }
        setSelectedString('')
        setLoader(false)
    }
    //validation
    function isMultiple(each) {

        if (each.multiple) {
            return true;
        }
        if (each.multiple === false) {
            return false;
        }
        if (props.module === 'reports' && each.key === "department") {
            return true;
        }
        // Trim any leading or trailing white spaces
        each.key = each.key.trim();
        // Check if the last character is an "s"
        if (each.key.endsWith("us")) {
            return false;
        }
        return each.key.endsWith('s');
    }

    const getPlaceholder = (each) => {
        const ph = each.placeholder;
        if (typeof ph === 'object' && ph.props !== undefined && ph.props.id !== undefined) {

            const lastString = ph.props.id.substring(ph.props.id.lastIndexOf('.') + 1);
            // Use a regular expression to insert space before capital letters
            const stringWithSpaces = lastString.replace(/([a-z])([A-Z])/g, '$1 $2');

            // Capitalize the first letter of the resulting string
            const capitilizeStr = stringWithSpaces.charAt(0).toUpperCase() + stringWithSpaces.slice(1);
            const res = capitilizeStr.replace('_id', ' ').replace('_', ' ')
            return res;
        }
        else {
            return ph
        }
    }
    //fields
    const InputField = ({ each }) => (
        <InputText placeholder={ each.placeholder } onChange={ val => onChange(each.key, val, each) } defaultValue={ selectedValues[each.key] === 'Invalid Date' ? '' : selectedValues[each.key] } />
    )
    const DateTimeField = ({ each }) => (
        <InputDate picker={ (each.key === 'month' || each.key === 'from_month' || each.key === 'end_month') ? 'month' : 'date' } format={ each.key === 'month' ? "YYYY MMM" : 'DD MMM YYYY' } onChange={ val => onChange(each.key, val, each) } placeholder={ getPlaceholder(each) } defaultValue={ selectedValues[each.key] } />
    )

    const isEmployeeFilter = (key) => key === 'employments' || key === 'employees' || key === 'employee' || key === 'employment';

    const SelectField = ({ each }) => (
        <>
            {
                each.data_key.split(".").reduce((obj, k) => obj && obj.hasOwnProperty(k) ? obj[k] : null, options) ?
                    <>
                        {
                            props.module === 'reports' && isEmployeeFilter(each.key) ? <BaseSelectWithTrashedResource modkey={ modkey } each={ each } disabled={ each.disabled } mode={ isMultiple(each) ? 'multiple' : '' } type={ each.resource_type } onChange={ val => onChange(each.key, val, each) } defaultValue={ selectedValues[each.key] !== undefined ? convertToArray(selectedValues[each.key]) : [] } /> :
                            each.key === 'employees' && each.onlyTrashed ? <BaseSelectTrashedResource modkey={ modkey } each={ each } disabled={ each.disabled } mode={ isMultiple(each) ? 'multiple' : '' } type={ each.resource_type } onChange={ val => onChange(each.key, val, each) } defaultValue={ selectedValues[each.key] ? convertToArray(selectedValues[each.key]) : [] } /> :
                                each.key === 'employments' || each.key === 'employees' || each.key === 'employee' ? <SelectResourceList modkey={ modkey } disabled={ each.disabled } mode={ isMultiple(each) ? 'multiple' : '' } type={ each.resource_type } onChange={ val => onChange(each.key, val, each) } defaultValue={ selectedValues[each.key] !== undefined ? convertToArray(selectedValues[each.key]) : [] } /> :
                                    <SelectWithSearch modkey={ modkey } mode={ isMultiple(each) ? 'multiple' : '' } placeholder={ getPlaceholder(each) } key={ each.key } defaultValue={ selectedValues[each.key] && !each.filterKey ? selectedValues[each.key] : each.filterKey ? selectedValues[each.key] : null } options={
                                        createSelectList(each.data_key.split(".").reduce((obj, k) => obj && obj.hasOwnProperty(k) ? obj[k] : null, options), { key: each.key, filterKey: each.filterKey }) } onChange={ val => onChange(each.key, val, each) } loading={ false } />
                        }

                    </>
                    : null }
        </>
    )

    const FilterField = (each, i) => {
        let item = null;
        switch (each.type) {
            case 'text':
                item = <InputField className="da-w-100" each={ each } />;
                break;
            case 'date':
                item = <DateTimeField className="da-w-100" each={ each } />;
                break;
            case 'select':
                item = <SelectField className="da-w-100" each={ each } />;
                break;
            default:
                return null;
        }

        return (
            <>
                <Col key={ i } className="gutter-row" xs={ 24 } sm={ 24 }>
                    <Form.Item label={ each.placeholder } name={ each.key } rules={ [
                        { required: each.required, message: 'This Field is Required' },
                    ] } >{ item }</Form.Item>
                </Col>
            </>
        );
    }

    return (
        <Drawer
            open={ true }
            onClose={ () => props.onCloseFilter(false) }
            placement="right"
            width={ 460 }
            maskClosable
            destroyOnClose
            className="base-filter-drawer"
            title={
                <div className="base-filter-drawer__header">
                    <div className="base-filter-drawer__title-row">
                        <span className="base-filter-drawer__title-icon"><FilterOutlined /></span>
                        <span className="base-filter-drawer__title-text">Filters</span>
                        <Spin spinning={ loading } size="small" />
                    </div>
                    {/* <div className="base-filter-drawer__subtitle">
                        Narrow down the records with the fields below.
                    </div> */}
                </div>
            }
            footer={
                <div className="base-filter-drawer__actions">
                    <Space className="base-filter-drawer__actions-inner">
                        <Button
                            className="base-filter-drawer__reset"
                            onClick={ onReset }
                        >
                            <span><SyncOutlined /> Reset</span>
                        </Button>
                        <Button
                            className="base-filter-drawer__apply"
                            type="primary"
                            htmlType="submit"
                            form="filterForm"
                            loading={ loader }
                        >
                            <span><SearchOutlined /> Apply</span>
                        </Button>
                    </Space>
                </div>
            }
        >
            <div className="base-filter-drawer__body">
                <Spin spinning={ false } tip="Loading...">
                    <Form { ...formLayout } form={ form } name='filterForm' onFinish={ onSubmit }>
                        <Row gutter={ [0, 0] }>
                            { filters.map((value, index) => FilterField(value, index)) }
                        </Row>
                    </Form>
                </Spin>
            </div>
        </Drawer>
    );
};

export default BaseFilter;

function isDateObj(dateString) {
    return typeof dateString === 'object' && dateString !== null && !
        Array.isArray(dateString) && !(dateString instanceof Date) && !(dateString instanceof RegExp) && !(dateString instanceof Error);
}

function normalizeFilterValues(values) {
    const normalized = {};

    Object.keys(values || {}).forEach((key) => {
        let value = values[key];

        if (value === undefined || value === null || value === '') {
            return;
        }

        if (Array.isArray(value)) {
            normalized[key] = value.join(',');
            return;
        }

        if (key === 'from' || key === 'to' || key === 'year' || key === 'completion_to' || key === 'completion_from') {
            normalized[key] = isDateObj(value) && typeof value.format === 'function' ? value.format('YYYY-MM-DD') : value;
            return;
        }

        if ((key === 'month' || key === 'from_month' || key === 'end_month') && isDateObj(value) && typeof value.date === 'function') {
            normalized[key] = value.date(1).hour(0).minute(0).second(0).millisecond(0).format('YYYY-MM-DD');
            return;
        }

        normalized[key] = value;
    });

    return normalized;
}
//---------------------form layout------------
//------------------------------------
const rules = {
    from: [
        { required: true, message: '' },
    ],
    to: [
        { required: true, message: '' },
    ],
};
const formLayout = {
    layout: "vertical",
    labelCol: { span: 6 },
    wrapperCol: { span: 24, },
    labelAlign: "left"
}
